import init from './thing'

const stage =
{
    ...init,
    status : { title : 'État' }
};

export default stage ;
